<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Preguntas frecuentes</span>
        </v-card-title>
        <v-card-text>
          <v-expansion-panel>
            <v-expansion-panel-content v-for="(faq, index) in faqs" :key="index">
              <template v-slot:header>
                <div>{{ faq.name }}</div>
              </template>
              <v-card>
                <object v-if="faq.url" :data="faq.url" width="100%" height="600px"></object>
                <v-flex v-else-if="faq.link" class="pa-4">
                  <v-btn :href="faq.link" target="blank" color="primary"><v-icon v-if="faq.icon" class="mr-2">{{ faq.icon }}</v-icon>{{ faq.label }}</v-btn>
                </v-flex>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" flat="flat" @click="close">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  export default {
    name: 'faqs-view',
    props: {
      dialog: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        faqs: [
          {name: 'Electronic payments / Pagos electrónicos', url: '/app/storage/app_files/p2p_faq.pdf?footer=0#toolbar=0'},
          {name: 'Enrollment process / Proceso matrículas', url: '/app/storage/app_files/proceso_matriculas.pdf?footer=0&ver=0.2#toolbar=0'},
          {name: 'Admission process / Proceso admisiones', url: 'https://docs.google.com/document/d/e/2PACX-1vRLxpO_dTqrvpeEJ7_O5uGWiHtxO-mPJiGAU_itiOBc68y2QPF6EucvhIEEXAoR3xd2lIDw5ofpVJ_y/pub?embedded=true'},
          {name: 'Virtual assembly access / Acceso asamblea virtual', link: 'https://app.columbus.edu.co/app/storage/guides/como_acceder_a_la_asamblea.mp4', label: 'Ver video tutorial', icon: 'movie_creation' },
        ]
      }
    },
    methods: {
      close() {
        this.$emit('close')
      }
    },
  }
</script>

<style>
.v-dialog .v-footer {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/faqs.vue